import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'components/Loader';

const ButtonSection = ({
  desactive,
  loading,
  className,
  labelCancel,
  labelExec,
  onToggle,
  onExec,
}) => (
  <div className="row padding-top-2">
    <div className="col-md-6 col-xs-12 pull-right">
      <div className={`col-sm-6 col-xs-12 ${className}`}>
        <button
          type="button"
          className="btn btn-default btn-block margin-top-05"
          onClick={onToggle}
        >
          {labelCancel}
        </button>
      </div>
      {!desactive && (
        <div className="col-sm-6 col-xs-12">
          {loading ? (
            <Loader active={loading} className="btn-block margin-top-05" />
          ) : (
            <button
              type="button"
              className="btn btn-primary btn-block margin-top-05"
              onClick={onExec}
            >
              {labelExec}
            </button>
          )}
        </div>
      )}
    </div>
  </div>
);

ButtonSection.propTypes = {
  desactive: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  labelCancel: PropTypes.string,
  labelExec: PropTypes.string,
  onExec: PropTypes.func,
  onToggle: PropTypes.func,
};

export default ButtonSection;
